import { calendarDisplayDate } from '../../../../utils/date-time';
import { AgendaAppointment } from './types';

export function toAgendaAppointments(schedules: any[] | undefined): AgendaAppointment[] {
    if (!Array.isArray(schedules) || schedules.length === 0) return [];

    return schedules.map((schedule: any) => ({
        title: schedule?.client?.name || 'Sem nome',
        startDate: schedule?.startAt ? calendarDisplayDate(schedule.startAt, schedule.timezone) : new Date(),
        endDate: schedule?.endAt ? calendarDisplayDate(schedule.endAt, schedule.timezone) : new Date(),
        schedule,
    }));
}

